"use client";

import { ReactNode, useMemo } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import FormProvider from "@/libs/shared/providers/FormProvider";

type FormLoginProviderProps = {
  children: ReactNode;
};

const FormLoginProvider = ({ children }: FormLoginProviderProps) => {
  const { t } = useTranslation();

  const validationSchema = useMemo(
    () =>
      yup.object({
        email: yup.string().required(t("common:error:required") || ""),
        password: yup.string().required(t("common:error:required") || ""),
      }),
    [t],
  );

  const options = useMemo(
    () => ({
      resolver: yupResolver(validationSchema) as any,
      mode: "onChange" as const,
    }),
    [validationSchema],
  );

  return <FormProvider {...options}>{children}</FormProvider>;
};

export default FormLoginProvider;
